export const determinePaginationButtonState = (
  currentPage,
  totalPages,
  totalItemsCount
) => {
  const isNextPageDisabled = currentPage === totalPages || totalItemsCount === 0
  const isDoubleNextPageDisabled =
    currentPage === totalPages || totalItemsCount === 0

  const isPrevPageDisabled = currentPage === 1
  const isDoublePrevPageDisabled = currentPage === 1

  return {
    isNextPageDisabled,
    isDoubleNextPageDisabled,
    isPrevPageDisabled,
    isDoublePrevPageDisabled,
  }
}
